import { render, staticRenderFns } from "./ConfigurationCart.vue?vue&type=template&id=2770a703&"
import script from "./ConfigurationCart.vue?vue&type=script&lang=js&"
export * from "./ConfigurationCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports